<template>
    <div>
        <div class="form-group bmd-form-group search-area m-0 mb-2">
            <div class="row">
                <div class="col-12 col-md-8 col-lg-9 m-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                        </div>
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput"
                               v-model="searchString">
                        <button type="button" class="d-inline-block btn btn-info mx-2 barcode"
                                @click="openBarcode"><i
                                class="fa fa-camera"></i></button>
                    </div>
                </div>
                <div class="col-12 col-md-4 col-lg-1 text-center m-2" v-if="fromEdit">
                    <button class="btn btn-danger" @click="onReturn">ثبت مرجوعی</button>
                </div>

                <div class="col-12 col-md-4 col-lg-1 text-center m-2">
                    <button class="btn btn-primary" @click="onModalShow">مشاهده فاکتور</button>
                </div>
            </div>


        </div>
        <div class="row" v-if="listView">
            <!--<div class="col-lg-12 mt-3 mb-1">
                <div class="category-item" v-for="item in categories">
                    <h4>{{item.name}}</h4>
                </div>
            </div>-->
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0}" class="card list" @click="onCardClicked($event, index)">
                    <div class="row">
                        <div class="col-md-4">
                            <strong>{{item.productName}}</strong>
                        </div>
                        <div class="col-md-2">
                            <span>موجودی اولیه: </span>
                            <span>{{item.stock}}</span>
                        </div>
                        <div class="col-md-2">
                            <span>تعداد: </span>
                            <span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>
                            <span v-else>{{item.unitVal}}</span>
                        </div>
                        <div class="col-md-4">
                            <span>قیمت: </span>
                            <span>{{item.price == null ? 0 :item.price.toLocaleString()}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-4 col-sm-6 product-container" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0}" class="card product mt-2 mb-2"
                     @click="onCardClicked($event, index)">
                    <div class="row p-2">
                        <div class="col-8">
                            <h5>{{item.productName}}</h5>
                            <span>موجودی انبار:</span>
                            <span>{{item.stock}}</span>
                            <br>
                            <span>قیمت:</span>
                            <span>{{item.price == null ? 0 : item.price.toLocaleString()}}</span>
                            <br>
                            <span>تعداد:</span>
                            <span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>
                            <span v-else>{{item.unitVal}}</span>
                            <br>
                            <span>بارکد:</span>
                            <span>{{item.barcode}}</span>
                        </div>
                        <div class="col-4">
                            <img src="../assets/img/placeholder.png" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 mt-5 text-center" v-if="products !== undefined && products.length < 1">
                <h3 class="no-item-alert">محصولی یافت نشد!</h3>
            </div>
            <div class="col-lg-12 mt-5"
                 :style="[autoload && products.length < dataCount ? {'height': '125px'} : {'height': 'initial'}]">
                <div class="sk-circle" id="loading"
                     :style="[autoload ? {'margin': '20px 0'} : {'margin': '100px auto'}]">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <div v-if="!autoload && products.length < dataCount" class="col-lg-12 text-center mb-3 mt-1"
                 @click="getProducts">
                <button class="btn btn-success">نمایش محصولات بیشتر</button>
            </div>
            <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="voucherTitle">محصولات فاکتور</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th class="text-nowrap">نام محصول</th>
                                        <th class="text-center text-nowrap">قیمت خرید</th>
                                        <th class="text-center text-nowrap">تعداد</th>
                                        <!--<th class="text-center text-nowrap">قیمت فروش</th>-->
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item,index) in cart">
                                        <td class="product-remove-button"><a class="text-danger"
                                                                             @click="onRemoveProductClicked(index)"><i
                                                class="fa fa-close"></i></a></td>
                                        <td class="text-nowrap">{{item.productName}}</td>
                                        <td class="text-center min-vw-100">
                                            <input class="form-control" style="min-width: 6rem;" type="number"
                                                   v-model="item.price">
                                        </td>
                                        <td class="text-center">
                                            <input class="form-control" style="min-width: 4rem;" type="number"
                                                   v-model="item.unitVal">
                                        </td>
                                        <!--<td class="text-center">-->
                                            <!--<input class="form-control" style="min-width: 6rem;" type="number"-->
                                                   <!--v-model="item.salesPrice">-->
                                        <!--</td>-->
                                    </tr>
                                    </tbody>
                                </table>
                                <h4 class="text-center no-item-alert mt-5" v-if="cart.length < 1">محصولی ثبت نشده
                                    است!</h4>
                            </div>
                            <div class="input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <input class="form-control" type="text" v-model="voucher.description"
                                       placeholder="توضیحات">
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-md-6 col-sm-6 w-100 text-right">

                                        <div class="row">
                                            <div class="col-md-6">
                                                <span>تعداد کل: </span>
                                                <span v-if="isNaN(voucher.overallAmount)" class="text-warning">تعداد به درستی وارد نشده است!</span>
                                                <span v-else>{{voucher.overallAmount}}</span>
                                                &nbsp;&nbsp;&nbsp;
                                            </div>
                                            <div class="col-md-6">
                                                <span>مبلغ کل: </span>
                                                <span v-if="isNaN(voucher.overallPrice)" class="text-warning">قیمت خرید به درستی وارد نشده است!</span>
                                                <span v-else>{{voucher.overallPrice.toLocaleString()}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" col-md-6 col-sm-6 w-100 text-right d-inline-flex">
                                        <button type="button" class="btn btn-secondary m-1" data-dismiss="modal">بستن
                                        </button>
                                        <!--<button type="button" class="btn btn-primary m-1" @click="onModalOk"-->
                                                <!--v-if="cart.length > 0">ذخیره-->
                                        <!--</button>-->
                                        <button type="button" class="btn btn-success m-1" @click="onPaymentClicked"
                                                v-if="cart.length > 0">پرداخت
                                        </button>
                                        <button type="button" class="d-inline-block btn btn-success m-1"
                                                @click="onPrintClicked"><i
                                                class="fa fa-print"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- ------------------------------------------------------------------------------------------->
        <div class="d-none" id="printMe">
            <h5>محصولات فاکتور</h5>
            <div class="table-responsive">
                <table class="table table-hover table-striped">
                    <thead>
                    <tr>
                        <th class="text-nowrap">نام محصول</th>
                        <th class="text-center text-nowrap">قیمت خرید</th>
                        <th class="text-center text-nowrap">تعداد</th>
                        <!--<th class="text-center text-nowrap">قیمت فروش</th>-->
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in cart">
                        <td class="text-nowrap">{{item.productName}}</td>
                        <td class="text-center text-nowrap">{{item.price}}</td>
                        <td class="text-center text-nowrap">{{item.unitVal}}</td>
                        <!--<td class="text-center text-nowrap">{{item.salesPrice}}</td>-->
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td class="text-center font-weight-bold">تعداد محصولات</td>
                        <td class="text-center font-weight-bold">{{voucher.overallAmount}}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td class="text-center font-weight-bold">جمع فاکتور</td>
                        <td class="text-center font-weight-bold">{{voucher.overallPrice.toLocaleString()}}</td>
                    </tr>
                    </tbody>
                </table>
                <h4 class="text-center no-item-alert mt-5" v-if="cart.length < 1">محصولی ثبت نشده
                    است!</h4>
            </div>
        </div>
        <!-- ------------------------------------------------------------------------------------------->
        <div class="modal fade" id="barcodeModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitle">خواندن بارکد
                            محصول</h5>

                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mt-3">
                        <div class="row">
                            <div class="col-12">

                                <StreamBarcodeReader
                                        @decode="(a, b, c) => onDecode(a, b, c)"
                                        @loaded="() => onLoaded()"
                                ></StreamBarcodeReader>
                                <h5 class="col-12 text-center m-3">{{ barcode || "هیچ بارکدی قرائت نشده، لطفا دوربین را روی بارکد بگیرید" }}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block mt-3">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <!--<button type="button" class="btn btn-danger mr-2" @click="onModalDelete">حذف</button>-->
                        <!--<button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>-->
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import EventBus from "../_framework/event-bus.js";
    import VueHtmlToPaper from 'vue-html-to-paper';
    import {StreamBarcodeReader} from "vue-barcode-reader";

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'buy-from-outsource',
        components: {
            StreamBarcodeReader
        },
        data() {
            return {
                products: [],
                categories: [],
                queryParams: {
                    pageSize: 18,
                    pageIndex: 0,
                    name: "",
                    outsourceId: 0,
                    showAll: false
                },
                searchString: "",
                modalProductName: "",
                cart: [],
                voucher: {
                    description: "",
                    serveOutSourceId: 0,
                    voucherProductDto: [],
                    outSourceName: "",
                    overallAmount: 0,
                    overallPrice: 0
                },
                tempVoucher: [],
                outSourceName: "",
                dataCount: 0,

                listView: false,
                autoload: false,

                userId: 0,
                companyId: 0,
                fromEdit: false,
                barcode: "",
            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);
            this.userId = localStorage.getItem("userId");
            this.companyId = localStorage.getItem("companyId");
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            this.queryParams.outsourceId = this.$route.params.id;

            // console.log(this.$route.params.voucher)
            this.fromEdit = this.$route.params.fromEdit;
            new BaseService('product').getList(this.queryParams).then(response => {
                this.products = response.data.data;
                this.dataCount = response.data.count;
                if (this.$route.params.voucher !== undefined) {
                    this.cart = this.$route.params.voucher.voucherProductDto;

                    this.validateProductsList();
                }
                $("#loading").hide();
            }).catch(error => {
                console.log(error)
                Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
            });
            new BaseService('outsource').getById(this.$route.params.id).then(response => {
                this.outSourceName = response.data.outSourceName;
            }).catch(error => {
                console.log(error)
                Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
            });

            if (localStorage.getItem(`tempVoucherBuy${this.userId}${this.companyId}`) === null) {
                localStorage.setItem(`tempVoucherBuy${this.userId}${this.companyId}`, "[]");
            }

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.products.length < this.dataCount) {
                        $("#loading").show();
                        this.getProducts();

                    }
                });
            }
        },
        methods: {
            getProducts() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('product').getList(this.queryParams).then(response => {
                    this.products.push.apply(this.products, response.data.data);
                    this.validateProductsList();
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onSearchInput() {
                this.queryParams.name = this.searchString;
                this.queryParams.pageIndex = 0;
                $("#loading").show();
                new BaseService('product').getList(this.queryParams).then(response => {
                    this.products = response.data.data;
                    this.validateProductsList();
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            validateProductsList() {
                for (let item of this.cart) {
                    for (let product of this.products) {
                        if (item.productName === product.productName) {
                            product.unitVal = item.unitVal;
                            product.price = item.salesPrice;
                            product.productId = item.productId;
                        }
                    }
                }
            },
            onCardClicked(e, index) {
                let flag = false;
                let i = 0;
                let offset = 0;
                for (let item of this.cart) {
                    if (item.productName === this.products[index].productName) {
                        flag = true;
                        offset = i;
                    }
                    i++;
                }
                if (flag === false) {
                    this.products[index].unitVal++;
                    Vue.set(this.products[index], "originalPrice", this.products[index].price);
                    Vue.set(this.products[index], "salesPrice", this.products[index].sellPrice);
                    this.cart.push(this.products[index]);
                } else {
                    this.cart[offset].unitVal++;
                    //this.products[index].unitVal++;
                }
            },
            onRemoveProductClicked(index) {
                for (let item of this.products) {
                    if (item.productName === this.cart[index].productName) {
                        /*item.count = 0;*/
                        item.unitVal = 0;
                        item.price = item.originalPrice;
                    }
                }
                this.cart.splice(index, 1);

            },
            onModalShow() {
                $("#voucherData").modal("show");
            },
            onModalOk() {
                if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                    for (let item of this.cart) {
                        item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                        item.price = item.price === null ? 0 : parseInt(item.price);
                        item.salesPrice = item.salesPrice === null ? 0 : parseInt(item.salesPrice);
                        Vue.set(item, "productId", item.id);
                    }
                    if (this.$route.params.voucher !== undefined) {
                        this.voucher = this.$route.params.voucher;
                        this.tempVoucher = JSON.parse(localStorage.getItem(`tempVoucherBuy${this.userId}${this.companyId}`));
                        this.tempVoucher[this.voucher.voucherIndex] = this.voucher;
                        localStorage.setItem(`tempVoucherBuy${this.userId}${this.companyId}`, JSON.stringify(this.tempVoucher));
                    } else {
                        this.voucher.voucherProductDto = this.cart;
                        this.voucher.serveOutSourceId = parseInt(this.queryParams.outsourceId);
                        this.voucher.outSourceName = this.outSourceName;

                        this.tempVoucher = JSON.parse(localStorage.getItem(`tempVoucherBuy${this.userId}${this.companyId}`));
                        this.tempVoucher.push(this.voucher);
                        localStorage.setItem(`tempVoucherBuy${this.userId}${this.companyId}`, JSON.stringify(this.tempVoucher));
                    }

                    $("#voucherData").modal("hide");
                    this.$noty.info("فاکتور ذخیره شد. برای تکمیل عملیات به بخش بایگانی، فاکتورهای باز مراجعه کنید.");
                    for (let item of this.products) {
                        item.unitVal = 0;
                        item.price = item.originalPrice;
                    }
                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }
                /*new BaseService('voucher').create(this.voucher).then(response => {
                    this.$noty.success("موفقیت آمیز!");
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                })*/
            },
            onPaymentClicked() {
                if (this.$route.params.fromEdit) {
                    if (confirm("در صورت تایید اطلاعات قبلی پرداخت خرید و کالاهای آن حذف میشوند و اطلاعات جدید جایگزین میشوند. آیا از پرداخت اطمینان دارید؟")) {
                        if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                            new BaseService('Voucher', `/DeleteVoucher/${this.$route.params.voucher.id}`).create().then(response => {

                                for (let item of this.cart) {
                                    item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                                    item.salesPrice = item.salesPrice === null ? 0 : parseInt(item.salesPrice);
                                    item.price = item.price === null ? 0 : parseInt(item.price);
                                    item.sellPrice = item.salesPrice;
                                    Vue.set(item, "productId", item.productId);
                                }
                                this.voucher.voucherProductDto = this.cart;
                                this.voucher.serveOutSourceId = parseInt(this.queryParams.outsourceId);
                                this.voucher.outSourceName = this.outSourceName;
                                $("#voucherData").modal("hide");
                                let obj = {
                                    name: 'payment',
                                    params: {
                                        voucher: this.voucher,
                                        type: "buy"
                                    }
                                };
                                this.$router.push(obj);
                            }).catch(error => {
                                console.log(error)
                                Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                            });


                        } else {
                            this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                        }
                    }
                } else {
                    if(this.voucher.description === ""){
                        this.$noty.warning('لطفا توضیحات فاکتور را وارد کنید');
                    }else {
                        if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                            for (let item of this.cart) {
                                item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                                item.salesPrice = item.salesPrice === null ? 0 : parseInt(item.salesPrice);
                                item.price = item.price === null ? 0 : parseInt(item.price);
                                item.sellPrice = item.salesPrice;
                                Vue.set(item, "productId", item.id);
                            }
                            this.voucher.voucherProductDto = this.cart;
                            this.voucher.serveOutSourceId = parseInt(this.queryParams.outsourceId);
                            this.voucher.outSourceName = this.outSourceName;
                            $("#voucherData").modal("hide");
                            let obj = {
                                name: 'payment',
                                params: {
                                    voucher: this.voucher,
                                    type: "buy"
                                }
                            };
                            this.$router.push(obj);
                        } else {
                            this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                        }
                    }
                }
            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            calculateOverallAmount() {
                let amount = 0;
                for (let item of this.cart) {
                    amount += parseInt(item.unitVal);
                }
                this.voucher.overallAmount = amount;
            },
            calculateOverallPrice() {
                let price = 0;
                for (let item of this.cart) {
                    price += (parseInt(item.unitVal) * parseInt(item.price));
                }
                this.voucher.overallPrice = price;
            },
            onReturn() {
                if (confirm("در صورت تایید اطلاعات پرداخت خرید و کالاهای آن حذف میشوند. آیا مرجوعی را تایید میکنید؟")) {
                    new BaseService('Voucher', `/DeleteVoucher/${this.$route.params.voucher.id}`).create().then(response => {


                        let obj = {
                            name: 'home',

                        };
                        this.$router.push(obj);
                    }).catch(error => {
                        console.log(error)
                        Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                    });
                }
            },
            onDecode(a, b, c) {
                console.log(a, b, c);
                this.barcode = a;
                this.searchString = a;
                this.onSearchInput();
                $("#barcodeModal").modal("hide");
                // if (this.id) clearTimeout(this.id);
                // this.id = setTimeout(() => {
                //     if (this.text === a) {
                //         this.text = "";
                //     }
                // }, 5000);
            },
            onLoaded() {
                console.log("load");
            },
            openBarcode() {
                this.barcode = "";
                $("#barcodeModal").modal("show");
            },
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                next(false);
            } else {
                next();
            }
        },
        watch: {
            cart: {
                handler(val) {
                    this.calculateOverallAmount();
                    this.calculateOverallPrice();
                },
                deep: true
            }
        }
    }
</script>
<style>
    @media (max-width: 991px) {
        .barcode {
            display: block !important;
        }
    }

    @media (min-width: 990px) {
        .barcode {
            display: none !important;
        }
    }
</style>